import { useStore } from 'effector-react'
import * as React from 'react'

import { $internalTransfer, internalTransferMounted } from './model'

export const useInternalTransfer = () => {
  const internalTransfer = useStore($internalTransfer)

  React.useEffect(() => {
    internalTransferMounted()
  }, [])

  return internalTransfer
}
